import request from '@/utils/request'
import { timeStamp } from '@/utils/tools'
import { pick } from 'ramda'
import { config } from '@/config'
import { getChannelId } from '@/utils/channel'
import md5 from 'crypto-js/md5'

function encryptPasswordFields(data, fields) {
  const nextData = { ...data }
  fields.forEach((field) => {
    if (nextData[field]) {
      nextData[field] = md5(nextData[field]).toString()
    }
  })
  return nextData
}

/*
  用户登录获取用户登录信息
 */
export function userInfo(data, commonCheck = true) {
  return request(
    'v1/user/info',
    {
      method: 'GET',
      params: {
        ...data
      }
    },
    {
      commonCheck
    }
  )
}
/*
  用户退出登录状态
 */
export function signout(data, commonCheck) {
  return request(
    'v1/user/logout',
    {
      method: 'POST',
      params: {
        ...data
      }
    },
    {
      commonCheck
    }
  )
}

// 弹窗登陆 ---------------------------------------------------------------开始
export function login(data, commonCheck) {
  return request(
    'v1/access/token',
    {
      method: 'POST',
      data: {
        from_platform: 10009,
        ...pick(['appId'], config),
        timeStamp: timeStamp(),
        ...data
      }
    },
    {
      serviceType: 1,
      commonCheck
    }
  )
}
export function checkBind(data) {
  return request('v1/wechat/checkBind', {
    method: 'POST',
    data: {
      ...data
    }
  })
}

export function checkBindVideoClip(data) {
  return request('v1/wechat/videoCheckBind', {
    method: 'POST',
    data: {
      ...data
    }
  })
}

export function qrcode(data) {
  return request('v1/wechat/qrcode', {
    method: 'POST',
    data: {
      ...data,
      channel_id: getChannelId()
    }
  })
}
export function qyConfigGet(data) {
  return request(
    'v1/user/qiyu/config',
    {
      method: 'GET',
      data: {
        ...data
      }
    },
    {
      serviceType: 1
    }
  )
}

export function getSendLoginCode(data) {
  return request(
    'v1/access/sendLoginCode',
    {
      method: 'POST',
      data: {
        ...pick(['appId'], config),
        ...data
      }
    },
    {
      serviceType: 1
    }
  )
}

export function sendCasCode(data) {
  return request(
    'v2/cas/sendcode',
    {
      method: 'POST',
      data: {
        ...pick(['appId'], config),
        ...data
      }
    },
    {
      serviceType: 2
    }
  )
}

export function casAuthorize(data) {
  return request(
    'v2/cas/authorize',
    {
      method: 'POST',
      data: {
        device: 'PC',
        ...pick(['appId'], config),
        ...data
      }
    },
    {
      serviceType: 2
    }
  )
}

export function getPhoneByCasToken(data) {
  return request('v1/user/getPhoneByCasToken', {
    method: 'POST',
    data
  })
}

export function createCommonToken(data) {
  return request('v1/user/createCommonToken', {
    method: 'POST',
    data: {
      ...pick(['appId'], config),
      ...data,
      channel_id: getChannelId()
    }
  })
}

// 根据手机获取账号注册和微信绑定状态
export function checkPhoneStatus(data) {
  return request('v1/user/checkPhoneStatus', {
    method: 'POST',
    data
  })
}

// 用户同意隐私策略
export function getPrivacyVerify() {
  return request('v1/user/privacy/verify', {
    method: 'GET'
  })
}
// 验证临时跳转的凭证
export function checkJump(data) {
  return request('v1/user/checkJump', {
    method: 'POST',
    data
  })
}

// 用户同意隐私策略
export function kolApply(data) {
  return request('v1/kol/apply', {
    method: 'POST',
    data: { ...data }
  })
}
// 首页弹窗判断
export function cooperationPopJudge(data, commonCheck = true) {
  return request(
    'v1/audit/cooperationPopJudge',
    {
      method: 'GET',
      params: { ...data }
    },
    {
      commonCheck
    }
  )
}

// 获取临时跳转的凭证
export function getTempRedirectTokenAPI(params) {
  return request(
    'v1/user/getJump',
    {
      method: 'GET',
      params
    },
    { commonCheck: false }
  )
}
// 用户同意隐私策略
export function confirmAuditTermination(data) {
  return request('v1/audit/confirmAuditTermination', {
    method: 'POST',
    data
  })
}
export function confirmAuditWarning(data) {
  return request('v1/audit/confirmAuditWarning', {
    method: 'POST',
    data
  })
}
export function checkAuditWarning(data) {
  return request('v1/audit/checkAuditWarning', {
    method: 'GET',
    params: {
      ...data
    }
  })
}
export function checkAuditTermination(data) {
  return request('v1/audit/checkAuditTermination', {
    method: 'GET',
    params: {
      ...data
    }
  })
}
export function checkAuditAuth(data) {
  return request('v1/audit/checkAuditAuth', {
    method: 'GET',
    params: {
      ...data
    }
  })
}
export function configList(params) {
  return request('v1/wxpublic/configList', {
    method: 'GET',
    params
  })
}

export function getBindStatus(data, commonCheck = false) {
  return request(
    'v1/user/bind/status',
    {
      method: 'GET',
      params: {
        ...data
      }
    },
    { commonCheck }
  )
}

export function sendSms(data) {
  return request('v1/send/sms', {
    method: 'POST',
    data
  })
}

export function bindMobile(data) {
  return request('v1/user/bind/mobile', {
    method: 'POST',
    data
  })
}

export function initPassword(data) {
  return request('v1/user/password/init', {
    method: 'POST',
    data: encryptPasswordFields(data, ['password'])
  })
}

export function resetPassword(data) {
  return request('v1/user/password/reset', {
    method: 'POST',
    data: encryptPasswordFields(data, ['old_password', 'new_password'])
  })
}

export function forgetPassword(data) {
  return request('v1/user/forgetPassword', {
    method: 'POST',
    data: encryptPasswordFields(data, ['password'])
  })
}
